import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import NewIVRModal from '../NewIVRModal';
import { DistributorActivity } from './DistributorActivity';
import DistributorEntryDialog from './DistributorEntryDialog';

export default function DistributorIvrs({
  clinics,
  loading,
  active = true,
  headingRef,
  statusFilter,
  onStatusFilterChange,
  readOnly = false,
  t,
}) {
  const [choosing, setChoosing] = useState(false);
  const [clinicId, setClinicId] = useState('');
  const [open, setOpen] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const selected = clinics.find((clinic) => clinic._id === clinicId);
  return (
    <div className="space-y-5">
      <DistributorActivity
        activityKind="ivrs"
        t={t}
        active={active}
        refresh={refresh}
        statusFilter={statusFilter}
        onStatusFilterChange={onStatusFilterChange}
        pageHeader={{
          headingRef,
          createAction: !readOnly && (
            <button
              type="button"
              className="me-dw-primary me-dw-create-action"
              disabled={loading || !clinics.length || choosing || open}
              onClick={() => setChoosing(true)}
            >
              <span className="material-symbols-outlined text-[18px]" aria-hidden="true">
                add
              </span>
              {t('New IVR')}
            </button>
          ),
        }}
      >
        {!readOnly && !loading && !clinics.length && (
          <p className="me-dw-card p-5 text-sm text-slate-600">
            {t('Add a customer before submitting an IVR.')}{' '}
            <Link to="/distributor/customers" className="me-dw-link">
              {t('Go to Customers')}
            </Link>
          </p>
        )}
        {!readOnly && choosing && (
          <DistributorEntryDialog
            open={active && choosing}
            title="New IVR"
            onClose={() => setChoosing(false)}
            t={t}
          >
            <label className="block text-sm font-semibold text-slate-700">
              {t('Choose a customer')}
              <select
                className="me-dw-field mt-2 block w-full max-w-md rounded-lg border px-3 py-2"
                value={clinicId}
                disabled={loading}
                onChange={(event) => setClinicId(event.target.value)}
              >
                <option value="">{t('Select customer')}</option>
                {clinics.map((clinic) => (
                  <option key={clinic._id} value={clinic._id}>
                    {clinic.name}
                  </option>
                ))}
              </select>
            </label>
            <div className="flex flex-wrap gap-3">
              <button
                type="button"
                className="me-dw-primary"
                disabled={!selected || loading}
                onClick={() => {
                  setChoosing(false);
                  setOpen(true);
                }}
              >
                {t('Continue to IVR')}
              </button>
              <button type="button" className="me-dw-link" onClick={() => setChoosing(false)}>
                {t('Cancel')}
              </button>
            </div>
          </DistributorEntryDialog>
        )}
        <NewIVRModal
          open={active && open && !readOnly}
          distributorClinicId={clinicId}
          readOnly={readOnly}
          onClose={() => setOpen(false)}
          onCreated={() => setRefresh((value) => value + 1)}
        />
      </DistributorActivity>
    </div>
  );
}
